import { Component, OnInit, Input, ViewChild, EventEmitter, Output, ChangeDetectorRef, AfterViewInit, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { DataSourceGrid } from '../data-source-grid.component';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Observable, Subject, ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-custom-grid',
  templateUrl: './custom-grid.component.html',
  styleUrls: ['./custom-grid.component.scss']
})
export class CustomGridComponent implements OnInit {

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('customGrid') customGrid: ElementRef;

  @Input()
  public dataObserver: Observable<any[]>;
  @Input()
  public data: any[] = [];
  public dataSource: DataSourceGrid;

  @Input()
  public minWidth: number = null;
  @Input()
  public displayedColumns = [];
  @Input()
  public namedColumns = [];
  @Input()
  public idRowSelector = '';
  @Input()
  public actionColumn = 'accion';

  @Input()
  public disableDownload = false;
  @Input()
  public disableEdit = false;
  @Input()
  public disableDelete = false;

  @Output()
  public deleteEvent: EventEmitter<number> = new EventEmitter();
  @Output()
  public editEvent: EventEmitter<number> = new EventEmitter();

  constructor() {    
  }

  ngOnInit() {
    this.customGrid.nativeElement.setAttribute('style', `min-width: ${this.minWidth};`);

    this.dataObserver.subscribe(newData => {
      this.data = newData;
      if (newData.length === 0) {
        this.dataSource = undefined;
      } else {
        this.dataSource = new DataSourceGrid(this.data, this.paginator, this.sort);
      }
    });

    this.dataSource = new DataSourceGrid(this.data, this.paginator, this.sort);
  }

  getCellValue(row, selector: string) {
    const multiSelectors = selector.split('.');

    if (multiSelectors.length > 1) {
      let actualValue = row;
      for (const select0r of multiSelectors) {
        actualValue = actualValue[select0r];
      }
      return actualValue;
    }
    return row[selector];
  }

  delete(row) {
    const cellValue = this.getCellValue(row, this.idRowSelector);
    this.deleteEvent.emit(cellValue);
  }

  edit(row) {
    const cellValue = this.getCellValue(row, this.idRowSelector);
    this.editEvent.emit(cellValue);
  }

  download() {

  }

}



// WEBPACK FOOTER //
// ./src/app/utils/custom-grid/custom-grid.component.ts